import { INoRowsOverlayAngularComp } from "ag-grid-angular";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { TableComponentState } from "../../../shared/types/TableComponentState";
import { NoRowsFunctionInfo } from "../../../shared/types/NoRowsFunctionInfo";
import { INoRowsOverlayParams } from "ag-grid-community";
import { Store } from "@ngrx/store";
import {  selectCreateRuleTableState } from "../../reducers";
import { Constants } from "../../../shared/utilities/Constants";

@Component({
  standalone: false,
    selector: 'mm-custom-error-create-rule-table',
    templateUrl: './custom-error-create-rule-table.component.html',
    styleUrls: ['./custom-error-create-rule-table.component.scss']
})

export class CustomErrorCreateRuleTableComponent implements OnInit, OnDestroy, INoRowsOverlayAngularComp {
    params: INoRowsOverlayParams & { noRowsMessageFn: () => NoRowsFunctionInfo  };
    tableState$: Observable<TableComponentState>;
    accountId: string;
    private destroy$ = new Subject<void>();
    readonly noActiveRuleHeader = Constants.noActiveRuleHeader;
    readonly noActiveRuleMsg = Constants.noActiveRuleMsg;

    constructor(private store: Store) { }

    ngOnInit(): void {
        this.tableState$ = this.store.select(selectCreateRuleTableState);
    }

    ngOnDestroy(): void {
        this.destroy$?.next();
        this.destroy$?.unsubscribe();
    }

    agInit(params: INoRowsOverlayParams & { noRowsMessageFn: () => NoRowsFunctionInfo  }): void {
        this.params = params;
    }
}